module.exports = __webpack_public_path__ + "je.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/je.svg
// module id = 623
// module chunks = 0